import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgErrorMarkDone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
      fill="url(#error-mark-done_svg__a)"
    />
    <path
      d="M9.107 23.169 22.86 9.126m-.002 14.043L9.108 9.126"
      stroke="#fff"
      strokeWidth={2}
    />
    <defs>
      <linearGradient
        id="error-mark-done_svg__a"
        x1={32}
        y1={32}
        x2={32}
        y2={0}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF8000" />
        <stop offset={1} stopColor="#CF0045" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgErrorMarkDone);
export default Memo;
